import { UntypedFormGroup } from "@angular/forms";
import { Cellstyle } from "~app/common/components/hot-doc/hotdoc/cell";
import { Kapkriteria } from "~app/common/models/constants";
import { Produktmatris } from "../Produktmatris";
import { PrismatrisCell } from "./prismatrisCell";

export class BegransningCell extends PrismatrisCell {
    value: number;
    prismatris: Produktmatris;

    constructor(
        prismatris: Produktmatris,
        form: UntypedFormGroup,
        flags?: Cellstyle) {
        super(prismatris, form, BegransningCell.fromKapkriterie(prismatris.kapkriteria), flags, (pm) => {
            prismatris.kapkriteria = BegransningCell.toKapkriterie(parseInt(pm.newValue, 10));
        });
    }

    static toKapkriterie(val: number): string {
        switch (val) {
            case 0:
                return Kapkriteria.ingaBegransningar;
            case -1:
                return Kapkriteria.forbjudetAttKapa;
            case -2:
                return Kapkriteria.endastVardeaptering;
            case -3:
                return Kapkriteria.endastManuellaKap;
            default:
                return null;
        }
    }

    static fromKapkriterie(kapkriterie: string): number {
        switch (kapkriterie) {
            case Kapkriteria.ingaBegransningar:
                return 0;
            case Kapkriteria.forbjudetAttKapa:
                return -1;
            case Kapkriteria.endastVardeaptering:
                return -2;
            case Kapkriteria.endastManuellaKap:
                return -3;
            default:
                return null;
        }
    }

    override validate(value: any): boolean {
        return BegransningCell.toKapkriterie(parseInt(value, 10)) !== null;
    }
}
